import { formatConfigTimeForCalendar, toCalendarDateOnly } from 'modules/calendar/calendarEventDates';
const MINUTES_PER_DAY = 24 * 60;
function toMinutes(value) {
    const formatted = formatConfigTimeForCalendar(value);
    const match = formatted ? /^(\d{1,2}):(\d{2})$/.exec(formatted) : null;
    if (!match) {
        return null;
    }
    return (Number(match[1]) * 60 + Number(match[2])) % MINUTES_PER_DAY;
}
/**
 * Plage d'une option. Sans heure de fin, la plage est un instant ; une fin
 * avant le début se termine le lendemain.
 */
export function toTimeSlot(startTime, endTime) {
    const start = toMinutes(startTime);
    if (start == null) {
        return null;
    }
    const end = toMinutes(endTime);
    if (end == null) {
        return { start, end: start };
    }
    return { start, end: end < start ? end + MINUTES_PER_DAY : end };
}
/**
 * Chevauchement sur des intervalles [début, fin) : des plages qui se touchent
 * ne se chevauchent pas.
 */
export function timeSlotsOverlap(a, b) {
    const aInstant = a.start === a.end;
    const bInstant = b.start === b.end;
    if (aInstant && bInstant) {
        return a.start === b.start;
    }
    if (aInstant) {
        return a.start >= b.start && a.start < b.end;
    }
    if (bInstant) {
        return b.start >= a.start && b.start < a.end;
    }
    return a.start < b.end && b.start < a.end;
}
/**
 * Date à laquelle une option est réservée : celle de sa ligne, sinon le
 * début de la soumission, comme au calendrier.
 */
export function getTimeSlotDate(dealItemDate, plannedDateStart) {
    var _a;
    return ((_a = toCalendarDateOnly(dealItemDate)) !== null && _a !== void 0 ? _a : toCalendarDateOnly(plannedDateStart));
}
